<template lang="pug">
  div(class="list curriculum-list media-list")
    ul
      unsent-curriculum-list-item(
        v-for="curriculum in curriculums"
        :key="curriculum.id"
        :curriculum="curriculum"
        @click="$emit('click', $event)"
        @send="$emit('send', $event)")
</template>

<style lang="scss" scoped>
.curriculum-list {
  margin: 0;
}
</style>

<script>
import UnsentCurriculumListItem from '@/components/molecules/UnsentCurriculumListItem'

export default {
  components: {
    UnsentCurriculumListItem,
  },
  props: {
    curriculums: {
      type: Array,
      required: true,
    },
  },
}
</script>
